import React from 'react';
import type { Props } from 'react-select';
import { Select } from '../Select';
import { CheckField } from '../CheckField';
import { Option } from './styles';

export function Combobox(props: Props) {
  const renderOption = (props: any) => {
    const { label, isSelected, innerRef, isFocused } = props;
    const { ...other } = props.innerProps;

    return (
      <Option {...other} ref={innerRef} isFocused={isFocused} data-option-value={props.data.value}>
        <CheckField
          type="checkbox"
          asContainer="div"
          label={label}
          value={label}
          readOnly={true}
          name={label}
          checked={isSelected}
        />
      </Option>
    );
  };

  return (
    <Select
      components={{
        Option: renderOption,
        MultiValueRemove: () => null
      }}
      isSearchable={false}
      isClearable={true}
      // @ts-ignore
      isMulti={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      {...props}
    />
  );
}

export type { Props as ComboboxProps };
